import React from 'react';
import { Box, Typography } from '@mui/material';
import { smartDeployBrand } from '../theme/brand';

export function SmartDeployMark({ size = 32, color = smartDeployBrand.colors.brightBlue, sx }) {
  return (
    <Box
      component="svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
      sx={{
        width: size,
        height: size,
        color,
        flex: '0 0 auto',
        display: 'block',
        ...sx,
      }}
    >
      <g fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeWidth="7">
        <line x1="32" y1="32" x2="32" y2="9" />
        <line x1="32" y1="32" x2="48.5" y2="15.5" />
        <line x1="32" y1="32" x2="55" y2="32" />
        <line x1="32" y1="32" x2="48.5" y2="48.5" />
        <line x1="32" y1="32" x2="32" y2="55" />
        <line x1="32" y1="32" x2="15.5" y2="48.5" />
        <line x1="32" y1="32" x2="9" y2="32" />
        <line x1="32" y1="32" x2="15.5" y2="15.5" />
        <circle cx="32" cy="32" r="10" stroke="none" />
        <circle cx="32" cy="8" r="7" stroke="none" />
        <circle cx="49" cy="15" r="7" stroke="none" />
        <circle cx="56" cy="32" r="7" stroke="none" />
        <circle cx="49" cy="49" r="7" stroke="none" />
        <circle cx="32" cy="56" r="7" stroke="none" />
        <circle cx="15" cy="49" r="7" stroke="none" />
        <circle cx="8" cy="32" r="7" stroke="none" />
        <circle cx="15" cy="15" r="7" stroke="none" />
      </g>
    </Box>
  );
}

export default function BrandLogo({
  markSize = 32,
  showWordmark = true,
  showTagline = false,
  inverse = false,
  compact = false,
  wordmarkFontSize,
  taglineFontSize,
  sx,
}) {
  const smartColor = inverse ? smartDeployBrand.colors.white : smartDeployBrand.colors.deepNavy;

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: compact ? 1 : 1.5, ...sx }}>
      <SmartDeployMark size={markSize} />
      {showWordmark && (
        <Box sx={{ minWidth: 0, lineHeight: 1 }}>
          <Typography
            component="span"
            sx={{
              display: 'block',
              fontWeight: 900,
              fontSize: wordmarkFontSize || (compact ? '0.95rem' : '1.15rem'),
              lineHeight: 1,
              color: smartColor,
              textDecoration: 'none',
              whiteSpace: 'nowrap',
            }}
          >
            SMART
            <Box component="span" sx={{ color: smartDeployBrand.colors.brightBlue }}>
              DEPLOY
            </Box>
          </Typography>
          {showTagline && (
            <Typography
              component="span"
              sx={{
                display: 'block',
                mt: 0.5,
                fontSize: taglineFontSize || (compact ? '0.56rem' : '0.68rem'),
                lineHeight: 1,
                fontWeight: 700,
                color: inverse ? smartDeployBrand.colors.lightGray : smartDeployBrand.colors.steelGray,
                textTransform: 'uppercase',
                whiteSpace: 'nowrap',
              }}
            >
              {smartDeployBrand.tagline}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
}
